import { useMapsLibrary } from '@vis.gl/react-google-maps';
import React, { useState, useRef, useEffect } from 'react';
import { useGoogleMap } from './GoogleMapContext';

interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
}

const PlaceAutocomplete = ({ onPlaceSelect }: PlaceAutocompleteProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState<any>();
  const inputRef = useRef<any>();
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      onPlaceSelect(placeAutocomplete.getPlace());
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <div className="autocomplete-container">
      <input
        ref={inputRef}
        style={{
          width: '400px',
          height: '32px',
          borderRadius: '4px',
          marginTop: '8px',
          border: '1px solid #dedede',
          fontSize: '14px',
          padding: '12px',
        }}
      />
    </div>
  );
};

export default PlaceAutocomplete;
